import OwnerModel from '../owner/owner-model';
import ProductModel from '../product/product-model';

export default class ProductgroupModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    seq: number;
    productgroup: any;
    productgroupCaption: string;
    productgroupLength: number;
    product: any;
    productCaption: string;
    productLength: number;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.seq = datarow.seq;
        this.productgroup = datarow.productgroup?.data?.map((d: any) => new ProductgroupModel(d));
        this.productgroupLength = this.productgroup?.length || 0;
        this.productgroupCaption = this.productgroupLength===0? '' : this.productgroup?.[0]?.name + (this.productgroupLength>1? ', ...': '');  
        this.product = datarow.product?.data?.map((d: any) => new ProductModel(d));
        this.productLength = this.product?.length || 0;
        this.productCaption = this.productLength===0? '' : this.product?.[0]?.name + (this.productLength>1? ', ...': '');  
        
        
    } 

    public static endPoint: string = 'product-groups' 
    public static endPointFilter = (parentId?: number) => {
       const owner = OwnerModel.getOwner();
       return ( '?populate=*&sort[0]=seq&sort[1]=name&filters[owner]=' +owner + '&filters[parent]' + (parentId? '=' + parentId : '[id][$null]=true'));
    } 
    public static url: string = '/productgroup';
    public static caption: string = 'Product Group';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),
        seq: 0,  
        productgroup: [],
        productgroupCaption: '',
        productgroupLength: 0,
        product: [],
        productCaption: '',
        productLength: 0,
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
}